import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ActivarUsuarioRequest,
  IGetInformacionPerfilUsuario,
  IGetInformacionUsuarioFormulario,
  RegistrarUsuarioRequest,
  RestablecerPasswordRequest,
  SolicitudRestablecerPasswordRequest
} from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class PortalUsuarioService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/usuario`;
  }

  registrarUsuario(request: RegistrarUsuarioRequest, archivoCedula: File): Observable<string> {
    const formData: FormData = new FormData();
    if (archivoCedula)
      formData.append('archivoCedula', archivoCedula);
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return this.http.post(`${this.baseUrl}/public/registrar-usuario`, formData, { responseType: 'text' });
  }

  isCodigoActivacionValido(codigo: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/public/is-codigo-activacion-valido/${codigo}`);
  }

  activarUsuario(request: ActivarUsuarioRequest): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/public/activar-usuario`, request);
  }

  solicitudRestablecerPassword(request: SolicitudRestablecerPasswordRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}/public/solicitud-restablecer-password`, request, { responseType: 'text' });
  }

  restablecerPassword(request: RestablecerPasswordRequest): Observable<string> {
    return this.http.put(`${this.baseUrl}/public/restablecer-password`, request, { responseType: 'text' });
  }

  isCodigoRestablecerPasswordValido(codigo: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/public/is-codigo-restablecer-password-valido/${codigo}`);
  }

  getInformacionUsuarioFormulario(): Observable<IGetInformacionUsuarioFormulario> {
    return this.http.get<IGetInformacionUsuarioFormulario>(`${this.baseUrl}/get-informacion-usuario-formulario`);
  }

  getInformacionPerfilUsuario(): Observable<IGetInformacionPerfilUsuario> {
    return this.http.get<IGetInformacionPerfilUsuario>(`${this.baseUrl}/get-informacion-usuario`);
  }

  actualizarUsuario(request:RegistrarUsuarioRequest):Observable<any>{
    const url = `${this.baseUrl}/actualizar`;
    return this.http.put(url,request);
  }
}
